
/**
 * 트윗 내용 정보
 */
export type CreateTweetBodyJsonDataContent = {
  /** @maxLength 280 */
  text: string;
};
